module.exports = __webpack_public_path__ + "img/L_QS.80b73313.png";